import { LitElement, html, svg } from 'lit';

export class IconDislike24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Tommel ned</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18.126 14.143c-2.283 1.674-5.4 4.46-7.827 8.358-.351.564-1.14.675-1.61.205l-.59-.59a1 1 0 0 1-.215-1.09l2.242-5.383H3a2 2 0 0 1-1.97-2.34l1.81-10.5a2 2 0 0 1 1.97-1.66h9.316l4 2.5M18.126 16.143h5v-14h-5v14Z"></path></svg>`; }
}
if (!customElements.get('f-icon-dislike24', IconDislike24)) {
  customElements.define('f-icon-dislike24', IconDislike24);
}